import { FC } from 'react'
import { RouteObject } from 'react-router-dom'
import { ArpDetails } from '../features/details-page'
import { Segment } from '../features/segment'


const StemDetailsPage: FC = () => (
  <Segment.ViewTracker attributes={{ path: '/stem'}}>
    <ArpDetails />
  </Segment.ViewTracker>
)

export const StemDetailsRoute: RouteObject = {
  path: '/stem',
  element: <StemDetailsPage />
}
